import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import { Button, ButtonGroup } from "aible";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import styles from "./style.module.css";
import { isAnalyticsReferenceChart } from "types/chat";
import { getMessageContentReferenceData } from "types/chat_conversation";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
const FewShotView = (props) => {
    const { nextId } = props;
    const viewMode = useSelector((state) => nextReducer.getFewShotViewMode(state, nextId));
    return React.createElement("div", null, viewMode === "NEW" ? React.createElement(NewFewShotModal, { ...props }) : React.createElement(ViewEditModal, { ...props }));
};
const ViewEditModal = (props) => {
    const { nextId, isOpen, onClose } = props;
    const dispatch = useDispatch();
    const fewShotExamples = useSelector((state) => nextReducer.getFewShotExamples(state, nextId));
    const fewShotText = useSelector((state) => nextReducer.getFewShotExample_Better(state, nextId));
    const selectedFewShotIndex = useSelector((state) => nextReducer.getSelectedFewShotIndex(state, nextId));
    const ignoredFewShots = useSelector((state) => nextReducer.getIgnoredFewShots(state, nextId));
    const viewMode = useSelector((state) => nextReducer.getFewShotViewMode(state, nextId));
    const conversationArray = useSelector((state) => chatGPTReducer.getConversationArray(state, undefined, true));
    const interactions = useSelector((state) => chatGPTReducer.getBasicInteractions(state, undefined, true));
    const [editPrompt, setEditPrompt] = useState();
    const [editResponse, setEditResponse] = useState();
    return (React.createElement(Dialog, { open: isOpen, onOpenChange: onClose },
        React.createElement(DialogContent, { size: "lg" },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null,
                    "View and Edit Few Shot Examples",
                    React.createElement(ButtonGroup, null,
                        React.createElement(Button, { active: viewMode === "ALL", onClick: () => dispatch(nextReducer.updateFewShotViewMode(nextId, "ALL")) }, "All"),
                        React.createElement(Button, { active: viewMode === "SELECTED", onClick: () => dispatch(nextReducer.updateFewShotViewMode(nextId, "SELECTED")) }, "Selected")))),
            React.createElement("div", { className: styles.fewShotBody },
                React.createElement("div", { className: styles.fewShotList },
                    viewMode === "SELECTED" ? "View Example:" : "Include Examples: ",
                    Object.keys(fewShotExamples).map((k, i) => {
                        return (React.createElement("div", { key: "fs_" + i, className: styles.fewShotItem +
                                " " +
                                (viewMode === "SELECTED" && selectedFewShotIndex === i
                                    ? styles.fewShotItemActive
                                    : viewMode !== "SELECTED" && ignoredFewShots?.[k] !== true
                                        ? styles.fewShotItemActive
                                        : ""), onClick: viewMode === "SELECTED"
                                ? () => dispatch(nextReducer.updateSelectedFewShotIndex(nextId, i))
                                : () => dispatch(nextReducer.updateIgnoredFewShots(nextId, {
                                    ...ignoredFewShots,
                                    [k]: !ignoredFewShots?.[k]
                                })) }, k + ": " + fewShotExamples[k]?.prompt));
                    })),
                React.createElement("div", { className: styles.fewShotExample }, viewMode === "ALL" ? (React.createElement("div", null,
                    "Full Few Shot Prompt Augment",
                    React.createElement("textarea", { className: styles.fewShotTextAreaExample, value: fewShotText, readOnly: true }))) : (React.createElement("div", null,
                    React.createElement("div", null,
                        "Prompt:",
                        React.createElement("textarea", { key: selectedFewShotIndex, className: styles.fewShotTextAreaExampleHalf, style: { height: "80px" }, defaultValue: fewShotExamples?.[selectedFewShotIndex]?.prompt, onChange: (val) => setEditPrompt(val?.currentTarget?.value) })),
                    fewShotExamples?.[selectedFewShotIndex]?.data_json_object && (React.createElement("div", null,
                        "Chart Data:",
                        React.createElement("textarea", { key: selectedFewShotIndex, className: styles.fewShotTextAreaExampleHalf, style: { height: "80px" }, value: fewShotExamples?.[selectedFewShotIndex]?.data_json_object, disabled: true, readOnly: true }))),
                    React.createElement("div", null,
                        "Response:",
                        React.createElement("textarea", { key: selectedFewShotIndex, className: styles.fewShotTextAreaExampleHalf, defaultValue: fewShotExamples?.[selectedFewShotIndex]?.response, onChange: (val) => setEditResponse(val?.currentTarget?.value) })))))),
            viewMode !== "ALL" && (React.createElement(DialogFooter, null,
                React.createElement(Button, { disabled: editPrompt === undefined && editResponse === undefined, onClick: () => {
                        const selFewShot = fewShotExamples?.[selectedFewShotIndex];
                        const fewShotMessage = conversationArray[selFewShot?.message_index];
                        const nCharts = editResponse !== undefined && fewShotMessage !== undefined
                            ? getMessageContentReferenceData(fewShotMessage).filter((f) => isAnalyticsReferenceChart(f) && f.text !== undefined && editResponse.indexOf(f.text) !== -1)
                            : undefined;
                        const retDataJson = nCharts === undefined
                            ? undefined
                            : fewShotMessage?.chatType !== "AIBLE"
                                ? undefined
                                : {
                                    Interactions: interactions,
                                    Charts: []
                                };
                        dispatch(nextReducer.updateFewShotExamples(nextId, {
                            ...fewShotExamples,
                            [selectedFewShotIndex]: {
                                ...fewShotExamples[selectedFewShotIndex],
                                prompt: editPrompt ?? selFewShot?.prompt,
                                response: editResponse ?? selFewShot?.response,
                                data_json_object: retDataJson !== undefined ? JSON.stringify(retDataJson) : selFewShot?.data_json_object
                            }
                        }));
                    } }, "Save"))))));
};
const NewFewShotModal = (props) => {
    const { nextId, isOpen } = props;
    const dispatch = useDispatch();
    const fewShotExamples = useSelector((state) => nextReducer.getFewShotExamples(state, nextId));
    const selectedFewShotIndex = useSelector((state) => nextReducer.getSelectedFewShotIndex(state, nextId));
    const conversationArray = useSelector((state) => chatGPTReducer.getConversationArray(state, undefined, true));
    const interactions = useSelector((state) => chatGPTReducer.getBasicInteractions(state, undefined, true));
    const removeLastFewShot = () => dispatch(nextReducer.removeLastFewShot(nextId));
    const updateIsOpenFewShotModal = (bool) => dispatch(nextReducer.updateIsOpenFewShotModal(nextId, bool));
    const handleCancelNewFewShot = () => {
        removeLastFewShot();
        updateIsOpenFewShotModal(false);
    };
    const [editPrompt, setEditPrompt] = useState();
    const [editResponse, setEditResponse] = useState();
    useEffect(() => {
        setEditPrompt(undefined);
        setEditResponse(undefined);
    }, [isOpen]);
    return (React.createElement(Dialog, { open: isOpen, onOpenChange: () => handleCancelNewFewShot() },
        React.createElement(DialogContent, { size: "lg" },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Use Examples to Immediately Improve the AI Responses (Few Shot)")),
            React.createElement("div", { className: styles.fewShotBody },
                React.createElement("div", { className: styles.fewShotExample },
                    React.createElement("div", null,
                        React.createElement("div", { className: styles.newFewShotModalBold }, "Prompt"),
                        React.createElement("textarea", { key: selectedFewShotIndex, className: styles.fewShotTextAreaExampleHalf, style: { height: "48px" }, defaultValue: fewShotExamples?.[selectedFewShotIndex]?.prompt, onChange: (val) => setEditPrompt(val?.currentTarget?.value) })),
                    React.createElement("div", null,
                        React.createElement("div", { className: styles.newFewShotModalBold }, "Edit the LLM Response (Optional)"),
                        React.createElement("textarea", { key: selectedFewShotIndex, className: styles.fewShotTextAreaExampleHalf, style: { height: "180px" }, defaultValue: fewShotExamples?.[selectedFewShotIndex]?.response, onChange: (val) => setEditResponse(val?.currentTarget?.value) })),
                    React.createElement("div", { className: styles.newFewshotModalTextLight }, "Saved few shots will be included in the LLM instructions as examples of your preferred behavior. You can review and edit all of your saved examples from the Prompt Augmentation section in the settings panel."))),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { onClick: () => handleCancelNewFewShot() }, "Cancel"),
                React.createElement(Button, { onClick: () => {
                        const selFewShot = fewShotExamples?.[selectedFewShotIndex];
                        const fewShotMessage = conversationArray[selFewShot?.message_index];
                        const nCharts = editResponse !== undefined && fewShotMessage !== undefined
                            ? getMessageContentReferenceData(fewShotMessage)?.filter((f) => isAnalyticsReferenceChart(f) && f.text !== undefined && editResponse.indexOf(f.text) !== -1)
                            : undefined;
                        const retDataJson = nCharts === undefined
                            ? undefined
                            : fewShotMessage?.chatType !== "AIBLE"
                                ? undefined
                                : {
                                    Interactions: interactions,
                                    Charts: []
                                };
                        dispatch(nextReducer.updateFewShotExamples(nextId, {
                            ...fewShotExamples,
                            [selectedFewShotIndex]: {
                                ...fewShotExamples[selectedFewShotIndex],
                                prompt: editPrompt ?? selFewShot?.prompt,
                                response: editResponse ?? selFewShot?.response,
                                data_json_object: retDataJson !== undefined ? JSON.stringify(retDataJson) : selFewShot?.data_json_object
                            }
                        }));
                        updateIsOpenFewShotModal(false);
                    } }, "Save")))));
};
export default FewShotView;
